import { render, staticRenderFns } from "./myContract.vue?vue&type=template&id=6b35c798&scoped=true&"
import script from "./myContract.vue?vue&type=script&lang=js&"
export * from "./myContract.vue?vue&type=script&lang=js&"
import style0 from "./myContract.vue?vue&type=style&index=0&id=6b35c798&scoped=true&lang=css&"
import style1 from "./myContract.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b35c798",
  null
  
)

export default component.exports